// extracted by extract-css-chunks-webpack-plugin
module.exports = {"contentbg":"#1d1c1b","lightgrey":"#948e7d","darkgrey":"#141112","textcolor":"#d8d5c3","textcolordisabled":"#5b554f","btncolor":"#83be55"};